import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { AppSettings } from '../shared/AppSettings';
@Injectable()
export class FundinstitutionService {

  readonly rootUrl = AppSettings.webApiURL;

  constructor(public httpClient: HttpClient) { }

  getFundinstitution() {
    return this.httpClient.get(`${this.rootUrl}/api/FundInstitution/GetList`);
  }
  getFundinstitutionById(fundInstitutionId: number) {
    return this.httpClient.get(`${this.rootUrl}/api/FundInstitution/GetFundInstitutionById?fundInstitutionId=${fundInstitutionId}`);
  }
  getBank() {
    return this.httpClient.get(`${this.rootUrl}/api/FundInstitution/GetListBank`);
  }
  setFundinstitutionById(obj: any) {
    return this.httpClient.put(`${this.rootUrl}/api/FundInstitution/Put`, obj);
  }
  delete(fundInstitutionId: number) {
    return this.httpClient.delete(`${this.rootUrl}/api/FundInstitution/Delete?FundInstitutionId=${fundInstitutionId}`);
  }
  post(fundInstitution: any) {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.httpClient.post(`${this.rootUrl}/api/FundInstitution/Post`, fundInstitution, { headers });
  }
}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/service/fundinstitution.service.ts